
webpack.register(
    'components/leaderboard/scorecard/scorecard',
    function() {
        return require('components/leaderboard/scorecard/scorecard');
    },
    false
);
webpack.register(
    'components/round-switcher/round-switcher',
    function() {
        return require('components/round-switcher/round-switcher');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/leaderboard/scorecard/scorecard'/>\r\n<can-import from='components/round-switcher/round-switcher'/>\r\n\r\n<div class=\"c-qualifying-leaderboard-drawer\">\r\n    <div class=\"drawer-head\">\r\n        <round-switcher {rounds-info}=\"data.player.roundsInfo\" {current-round}=\"data.player.currentRound.number\" {^round}=\"round\" max-rounds=\"2\"></round-switcher>\r\n        <button class=\"drawer-head__close js-drawer-close\" aria-label=\"close\">CLOSE</button>\r\n    </div>\r\n\r\n    <div class=\"drawer-content clearfix\">\r\n        <div class=\"drawer-cell cell-scorecard\" data-type=\"scorecard\">\r\n            <!--SCORECARD-->\r\n            <div class=\"container-scorecard\">\r\n                <leaderboard-scorecard {round}=\"round\" {current-round}=\"data.player.currentRound.number\" {rounds-info}=\"data.player.roundsInfo\" show-yards=\"false\" {player}=\"data.player\"></leaderboard-scorecard>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");